import React from 'react'
import { Route, Routes, useParams } from 'react-router-dom';
import routes from '../../../Router/router';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import "./Content.css"

const Content = () => {

    return (
        <div className="" style={{ overflowY: "auto" }}>
            {/* <Navbar /> */}
            <div className="main-content container-fluid contentPage" style={{ padding: "0px" }}>
                <Routes>
                    {routes.map((route, idx) => {
                        return (
                            route.component && (
                                <Route
                                    key={idx}
                                    path={route.path}
                                    // exact={route.exact}
                                    name={route.name}
                                    element={<route.component />}
                                />
                            ))
                    })}
                </Routes>
                <Footer />
            </div>
        </div>
    )
}

export default Content